import { closeLinkContextMenu } from '../../components/LinkContextMenu';
import datapoints from '../../datapoints';
import ComposeLinkViewState from '../../store/schema/ComposeLinkViewState';
import { logUsage } from 'owa-analytics';
import { getAttachmentPermissionLevelString, ONE_DRIVE_PRO } from 'owa-attachment-link-common';
import { isFeatureEnabled } from 'owa-feature-flags';
import { updateSharePointLinkUrl } from 'owa-link-data';
import { refreshSharingTipsForLink } from 'owa-link-data';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import CreateAttachmentSharingLinkResponse from 'owa-service/lib/contract/CreateAttachmentSharingLinkResponse';
import {
    createSharingLink,
    getSharingLink,
    SharingLinkInfo,
    updateSharePointLinkPermission,
} from 'owa-link-data';
import {
    IContextualMenuItem,
    IContextualMenuProps,
} from 'office-ui-fabric-react/lib/ContextualMenu';

const styles = require('../../components/LinkContextMenu.scss');

export function getChangePermissionContextMenuItem(
    composeLinkViewState: ComposeLinkViewState
): IContextualMenuItem {
    if (isFeatureEnabled('doc-attachment-sharingDialog')) {
        return null;
    }

    const sharingLinkInfo = getSharingLink(composeLinkViewState.linkId);
    return {
        text: getAttachmentPermissionLevelString(sharingLinkInfo.permissionLevel, ONE_DRIVE_PRO),
        key: 'changePermission',
        className: styles.smallFontContextMenu,
        subMenuProps: getSupportedPermissionLevelsSubMenuItems(sharingLinkInfo),
    };
}

export function getSupportedPermissionLevelsSubMenuItems(
    sharingLinkInfo: SharingLinkInfo
): IContextualMenuProps {
    const subMenuItems: IContextualMenuItem[] = [];

    if (sharingLinkInfo.supportedPermissionLevels) {
        sharingLinkInfo.supportedPermissionLevels.forEach(permissionLevel => {
            if (
                isFeatureEnabled('doc-attachment-docLinksProperty') ||
                (permissionLevel !== AttachmentPermissionLevel.View &&
                    permissionLevel !== AttachmentPermissionLevel.Edit)
            ) {
                const permission = getAttachmentPermissionLevelString(
                    permissionLevel,
                    ONE_DRIVE_PRO
                );
                subMenuItems.push({
                    text: permission,
                    key: permission,
                    title: permission,
                    onClick: () => {
                        logUsage(datapoints.AttachmentLinkViewChangePermission.datapoint.name);
                        setSharingLinkPermission(permissionLevel, sharingLinkInfo);
                        closeLinkContextMenu();
                    },
                    isChecked: permissionLevel === sharingLinkInfo.permissionLevel,
                    canCheck: true,
                });
            }
        });
    }
    if (subMenuItems.length > 0) {
        return {
            items: subMenuItems,
            className: styles.fixWidthContextMenu,
            directionalHintFixed: true,
        };
    } else {
        return null;
    }
}

async function setSharingLinkPermission(
    newPermissionLevel: AttachmentPermissionLevel,
    sharingLinkInfo: SharingLinkInfo
) {
    if (newPermissionLevel === sharingLinkInfo.permissionLevel) {
        return true;
    }

    const sharingUrl = getSharingUrlsForPermissionLevel(newPermissionLevel, sharingLinkInfo);

    updateSharePointLinkPermission(sharingLinkInfo.linkId, newPermissionLevel);
    if (sharingUrl) {
        updateSharePointLinkUrl(sharingLinkInfo.linkId, sharingUrl, sharingLinkInfo.url);
    } else {
        //TODO: VSO 36802 - add error checking code
        const response: CreateAttachmentSharingLinkResponse = await createSharingLink(
            sharingLinkInfo.sharingInfo.canonicalUrl,
            newPermissionLevel
        );

        updateSharePointLinkUrl(sharingLinkInfo.linkId, response.Link, sharingLinkInfo.url);
    }
    refreshSharingTipsForLink(sharingLinkInfo.linkId);

    return true;
}

function getSharingUrlsForPermissionLevel(
    newPermissionLevel: AttachmentPermissionLevel,
    sharingLinkInfo: SharingLinkInfo
): string | null {
    // For anonymous links we should aways return null, as the current url could be expired
    switch (newPermissionLevel) {
        case AttachmentPermissionLevel.OrganizationEdit:
            return sharingLinkInfo.sharingUrls.organizationEditLink;
        case AttachmentPermissionLevel.OrganizationView:
            return sharingLinkInfo.sharingUrls.organizationViewLink;
        case AttachmentPermissionLevel.Edit:
        case AttachmentPermissionLevel.View:
        case AttachmentPermissionLevel.None:
            return sharingLinkInfo.sharingInfo.canonicalUrl;
        default:
            return null;
    }
}
